import React, { useEffect, useState } from 'react'
import { Country, State, City } from 'country-state-city';
import csc from 'country-state-city';
import Api from '../../Api/Api'
import { AiFillDelete, AiOutlinePlus, AiOutlineMinus } from 'react-icons/ai';
import NavBar from '../Navbar'
import { Link, useHistory } from 'react-router-dom';

function AllAddress() {

  const [data, setData] = useState([])
  const history = useHistory()

  const getAddresses = async () => {
    try {
      const { data } = await Api.getAddresses();
      setData(data)
      console.log(data);
    } catch (e) {
      console.log(e);
    }
  }
  useEffect(() => {
    getAddresses()
  }, [])


  const handleDelete = async (id) => {
    try {
      const data = await Api.deleteAddress(id);
      getAddresses()
      console.log(data);
    } catch (e) {
      console.log(e);
    }
  }


  return (
    <>
      <NavBar />
      <div className='container mt-5'>
        <div className="row bg-light container rounded mt-5 mb-3">
          <h2 className='my-4 text-center'><b>All Addresses</b></h2>
          <div className='col-12 mb-5'>
            <div className='d-flex justify-content-end mb-4'>
              <Link to={"/addaddress"}>
                <button className='btn btn-primary'>Add New Address</button>
              </Link>
            </div>
            <div>
              {data?.map((address, index) => (
                <div key={index} className="container d-flex justify-content-between mb-3" style={{ opacity: "0.7", backgroundColor: "rgb(225, 226, 180)" }}>
                  <b className='my-1'>
                    Name: {address.Name}<br />
                    address1: {address.Address_Line_1}<br />
                    pincode: {address.Pin_Code}<br />
                    phone: {address.Contact_Number}<br />
                    country: {address.Country}<br />
                    state: {address.State}<br />
                    city: {address.City}
                  </b>
                  <div className='my-auto'>
                    <Link to={`/editaddress/${address._id}`}>
                      <button className='btn btn-success ms-1 me-2  mb-2'>Edit</button>
                    </Link>
                    <button className='btn btn-danger ms-1 me-2 mb-2' onClick={() => { handleDelete(address._id) }}>Delete</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AllAddress